import clsx from 'clsx'
import RadioButtonUncheckedIcon from '../internal/svg-icons/RadioButtonUnchecked'
import RadioButtonCheckedIcon from '../internal/svg-icons/RadioButtonChecked'
import style from './radioButton.module.scss'

export interface RadioButtonIconClasses {
  /** Styles applied to the root element. */
  root: string
  /** Styles applied to RadioButton background */
  background: string
  /** Style applied to the Dot in RadioButton */
  dot: string
  /** Style applied to the Dot when RadioButton is checked */
  checked: string
}

interface RadioButtonIconProps {
  /**
   * If `true`, the component is checked.
   */
  checked?: boolean
  /**
   * Override or extend the styles applied to the component.
   */
  classes?: Partial<RadioButtonIconClasses>
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */
  size?: 'small' | 'medium' | 'large'
}

export function RadioButtonIcon(props: RadioButtonIconProps) {
  const { checked = false, classes = {}, size = 'medium' } = props
  const iconSize = {
    small: 16,
    medium: 20,
    large: 24,
  } as const
  return (
    <span className={clsx(style.root, classes.root)}>
      <RadioButtonUncheckedIcon
        fontSize={iconSize?.[size]}
        className={clsx(style.background, classes.background)}
      />
      <RadioButtonCheckedIcon
        fontSize={iconSize?.[size]}
        className={clsx(
          style.dot,
          classes.dot,
          checked && [style.checked, classes.checked]
        )}
      />
    </span>
  )
}
